import React, { FC, useRef, useState } from 'react';
import _ from 'lodash';
import { addComma } from 'src/utils/common';
import { dateFormat } from 'src/utils/dateSet';
import IconButton from 'src/components/atoms/buttons/IconButton';
import DefaultButton from 'src/components/atoms/buttons/DefaultButton';
import CheckBox from 'src/components/atoms/CheckBox';

export const gridOption = (data: any, totalCount: number, bindStateData: any) => {
  const gridData = _.cloneDeep(data) || [];
  const disableEvent = (e: React.MouseEvent) => {
    e.stopPropagation();
  };
  const gridFnc = {
    viewContent: (param: any) => {
      const clickEvt = (e: any) => {};
      const checkClickEvt = (e: any) => {};
      return (
        <div className="_custom_div_left">
          <div className="_txt">{param[0]}</div>
          {/* <div className="_r_div">
            <div className="_item">
              <DefaultButton
                text="가이드"
                clickEvent={e => clickEvt(e)}
                icon="ri-file-unknow-line"
                iconStyleDef={{ fontSize: '14px', paddingTop: '0px' }}
                type="type1"
                styleDef={{ height: '28px', fontSize: '12px', width: '75px', color: '#555' }}
              />
            </div>
            <div className="_item">
              <DefaultButton
                text="서류 업로드"
                clickEvent={e => clickEvt(e)}
                icon="ri-file-text-line"
                iconStyleDef={{ fontSize: '14px', paddingTop: '0px' }}
                type="type1"
                styleDef={{ height: '28px', fontSize: '12px', width: '105px', color: '#555' }}
              />
            </div>
            <div className="_item">
              <CheckBox label="서면확인" type="_t1" selected="off" btnClickEvt={checkClickEvt} />
            </div>
          </div> */}
        </div>
      );
    },
    createDate: (param: any) => {
      return dateFormat(param[0], 'YYYY.MM.DD HH:mm');
    },
    viewCount: (param: any) => {
      const count = param[0] || 0;
      return addComma(count);
    },
  };

  // gridData
  const gridOption = {
    label: [
      {
        label: '',
        col: 'id',
        width: '0px',
        align: 'left',
        useYN: 'none',
      },
      {
        label: '성명',
        col: 'name',
        width: '150px',
        align: 'left',
        sort: { use: false, active: false, status: 'desc' },
        style: { fontSize: '13px' },
      },
      {
        label: '문서종류',
        col: 'docType',
        width: 'calc(100% - 150px)',
        align: 'left',
        sort: { use: false, active: false, status: 'desc' },
        custom: { fn: gridFnc.viewContent, param: ['docType'] },
      },
    ],
    styleDef: { width: '100%', fontSize: '13px' },
    data: gridData,
    totalCount: totalCount,
  };

  return gridOption;
};
